import React, { useState } from 'react';
import App from './app/app';
import { Provider, ReactReduxContext } from 'react-redux';
import store from './store/store';
import { BrowserRouter } from 'react-router-dom';
import { StyledEngineProvider, ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import { LocalizationProvider as MuiXDatePickerLocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import MomentUtils from '@date-io/moment';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { TouchBackend } from 'react-dnd-touch-backend';
import { isDesktop } from 'react-device-detect';
import { themeObjectDark, themeObjectLight } from './app/themes';
import ErrorBoundary from './controls/errorBoundary';
import SystemSnackbarProvider from './components/snackbar/systemSnackbarProvider';
import { WebSocketProvider } from './context/WebSocketProvider';
import _ from 'lodash';

let localStorageThemKey = 'fortrus_agyle_theme';
if (process.env.BUILD_MODULE === 'lwh' || process.env.BUILD_MODULE === 'dch' || process.env.BUILD_MODULE === 'mse') {
    localStorageThemKey = 'fortrus_holding_theme';
}

function Main() {
    window._themes = { dark: themeObjectDark, light: themeObjectLight };
    const [theme, setTheme] = useState(_.get(window, '_themes.dark', themeObjectDark));
    window._theme = theme;

    let params = new URLSearchParams(window.location.search);
    let iFrameAdmission = false;
    iFrameAdmission = params.get('view') === 'admissions_iframe';
    iFrameAdmission = params.get('view') === 'admissions_patient_iframe' || iFrameAdmission;

    window._getTheme = () => {
        const themeName = window.localStorage.getItem(localStorageThemKey);
        if (process.env.BUILD_MODULE === 'lwh' || process.env.BUILD_MODULE === 'dch' || process.env.BUILD_MODULE === 'mse') {
            return 'dark';
        }
        return themeName ? themeName : 'light';
    };

    window._getThemeObject = (themeName) => {
        return themeName === 'dark' ? _.get(window, '_themes.dark', themeObjectDark) : _.get(window, '_themes.light', themeObjectLight);
    };
    window._switchTheme = () => {
        const newTheme = window._getTheme() === 'dark' ? 'light' : 'dark';
        window.localStorage.setItem(localStorageThemKey, newTheme);
        setTheme(window._getThemeObject(newTheme));
    };
    window._setTheme = (themeName) => {
        if (process.env.BUILD_MODULE === 'lwh' || process.env.BUILD_MODULE === 'dch' || process.env.BUILD_MODULE === 'mse') {
            themeName = 'dark';
        }
        window.localStorage.setItem(localStorageThemKey, themeName);
        setTheme(window._getThemeObject(themeName));
    };

    // let backend = ('ontouchstart' in window) || (navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0) ? TouchBackend : HTML5Backend;
    let backend = isDesktop ? HTML5Backend : TouchBackend;

    // if ((new URL(document.location)).searchParams.get("touch") === "false") {
    //     backend = HTML5Backend;
    // }

    return (
        <React.StrictMode>
            <Provider store={store}>
                <DndProvider backend={backend}>
                    <StyledEngineProvider injectFirst>
                        <ThemeProvider theme={theme}>
                            <MuiXDatePickerLocalizationProvider dateAdapter={AdapterMoment}>
                                <CssBaseline />
                                <BrowserRouter>
                                    <LocalizationProvider dateAdapter={MomentUtils}>
                                        <SystemSnackbarProvider>
                                            <ErrorBoundary>
                                                <WebSocketProvider>
                                                    <App isFrame={iFrameAdmission} />
                                                </WebSocketProvider>
                                            </ErrorBoundary>
                                        </SystemSnackbarProvider>
                                    </LocalizationProvider>
                                </BrowserRouter>
                            </MuiXDatePickerLocalizationProvider>
                        </ThemeProvider>
                    </StyledEngineProvider>
                </DndProvider>
            </Provider>
        </React.StrictMode>
    );
}

export default Main;
